import Validator from "validatorjs";
import { PASSREGEX } from "@constants/regex";

export const validate = ({ newPassword, reenterNewPassword }) => {
  // NOTE: Since validatorjs doesn't handle multiple regex fields - we are building custom error messages to
  // give user more precise feedback.

  const errors = {};

  if (newPassword && !PASSREGEX.test(newPassword)) {
    errors.newPassword = "Invalid password";
    return errors;
  }

  if (reenterNewPassword && newPassword !== reenterNewPassword) {
    errors.reenterNewPassword = "Passwords do not match.";
    return errors;
  }

  return;
};

export const checkIfEmpty = props => {
  const rules = {
    oldPassword: "required",
    newPassword: "required",
    reenterNewPassword: "required"
  };

  const errorMessages = {
    "required.oldPassword": "Old Password is required.",
    "required.newPassword": "New password is required.",
    "required.reenterNewPassword": "Please re-enter new password."
  };

  const validator = new Validator(props, rules, errorMessages);

  validator.passes();
  return validator.errors.all();
};
